import Route from '@ember/routing/route';

export default class CareerPathwaysPslfVaultRoute extends Route {}
